import { t } from 'i18next';

import { SubmitOrderOutcome } from 'dashboard/enums';

// Inclusive span limit, mirroring MAX_RANGE_DAYS in the BE validation. Enforced
// twice on purpose: the pickers clamp interactive selection, the schema catches
// typed-in dates (min/maxDate only gray the calendar, they don't block typing).
export const MAX_RANGE_DAYS = 366;

export const getSubmitOrderOutcomeLabels = (): Record<SubmitOrderOutcome, string> => ({
  [SubmitOrderOutcome.FAILED]: t('labelFailed'),
  [SubmitOrderOutcome.NO_RESPONSE]: t('labelNoResponse'),
  [SubmitOrderOutcome.SUCCESS]: t('labelSuccess'),
});

// The stored payload is either decoded JSON or a raw string (when the logged text
// was not valid JSON). Pretty-print the former, pass the latter through untouched:
// what the panel shows and what the clipboard gets must stay key-for-key identical
// to what was sent, never re-cased. A decoded body is re-serialised here, so the
// whitespace is ours; the keys and values are not.
export const payloadToText = (payload: unknown): string =>
  typeof payload === 'string' ? payload : JSON.stringify(payload, null, 2);
